import { dictData } from "@/api/dict.js"

export default {
    state: {
        dicts: [],
    },

    mutations: {
        setDictData: (state, data) => {
            state.dicts.unshift(data)
        },
    },

    actions: {
        getDictData({ commit, state }, dictKey) {
            return new Promise((resolve, reject) => {
                let _is_in_local = false;
                for (let i = 0; i < state.dicts.length; i++) {
                    const element = state.dicts[i];
                    if (element.key == dictKey) {
                        resolve(element.data);
                        _is_in_local = true;
                        break;
                    }
                }
                if (_is_in_local == false) {
                    dictData(dictKey).then(res => {
                        if (res.code == 200) {
                            commit("setDictData", { key: dictKey, data: res.data })
                        }
                        resolve(res)
                    }).catch(err => {
                        reject(err)
                    })
                }
            })
        },
    }
}
